import { atom } from 'jotai';

/** In-memory prefill for Link-to-Expert reference message; not persisted in URL. */
export const referenceMessageBodyAtom = atom('');
